export default (hit, isInit) => {
  return `
  <a onclick="_paq.push(['trackEvent', 'engages-passionnes', '${hit.thematic === 'video' ? 'video' : hit.thematic === 'testimony' ? 'témoignage' : 'podcast'}', '${hit.thematic === 'video' ? 'Lire la vidéo' : hit.thematic === 'testimony' ? 'Lire le témoignage' : 'Ecouter le podcast'}']);" href="${hit.path}" class="card text-white">
    <div class="card__picto rounded-top-right">
        ${hit.thematic === 'video'
        ? `<svg width="24" height="21" class="icon--white">
              <use href="#icon-play" xlink:href="#icon-play" />
          </svg>`
        : hit.thematic === 'testimony'
          ? `<svg width="48" height="48" class="icon--white">
              <use href="#icon-testimony" xlink:href="#icon-testimony" />
            </svg>`
          : `<svg width="42" height="38" class="icon--white card__picto-lightning">
                <use href="#icon-lightning" xlink:href="#icon-lightning" />
            </svg>
            <svg width="19" height="29" class="icon--white">
                <use href="#icon-mic" xlink:href="#icon-mic" />
            </svg>`
        }
    </div>

    <div class="object-fit-image-wrap card__bg-wrap has-overlay overflow-hidden card--${hit.tag && hit.tag.length > 0 ? hit.tag[0] : 'no-tag'}">
        <img class="card__bg object-fit-image" src="https://res.cloudinary.com/dl8lvr6ag/image/upload/c_fill,f_auto,q_auto,w_384,h_540/${hit.picture.singleMedia.publicId}" alt="" />
    </div>

    <p class="title title--5 text-center mt-1 pb-8">
      ${hit.thematic === 'video' ? config.trads['committed.video'] : hit.thematic === 'testimony' ? config.trads['committed.testimony'] : 'Vachement bien'}
    </p>

    <div>
        ${hit.tag
          ? hit.pillarName.map((tag, i) => {
            return (
              `<span class="tag tag--${hit.tag[i]} mb-2 ${i !== hit.tag.length - 1 ? 'mr-1' : ''}">${tag}</span>`
            )
          }).join('')
          : ''
        }

        <p class="title title--4 mt-4">
          ${hit.type === 'testimony' ? '« ' : ''}
          ${hit.title}
          ${hit.type === 'testimony' ? ' »' : ''}
        </p>

        <span class="cta cta--icon mt-4">
            ${hit.thematic === 'video'
              ? ` ${config.trads['video.play']}
                  <svg width="8" height="9" class="icon--white">
                      <use href="#icon-play" xlink:href="#icon-play" />
                  </svg>
                `
              : hit.thematic === 'testimony'
                ? `${config.trads['testimony.read']}
                    <svg width="13" height="10" class="icon--white">
                      <use href="#icon-arrow-right" xlink:href="#icon-arrow-right" />
                    </svg>
                  `
                : `${config.trads['podcast.listen']}
                    <svg width="14" height="12" class="icon--white">
                        <use href="#icon-headphone" xlink:href="#icon-headphone" />
                    </svg>
                  `
            }
        </span>
    </div>
  </a>
  `
}
